const trafo = {
  get_diversity_data: "/api/powerdata/ADMD_DataExtraction",
  get_life_lost_data: "/api/powerdata/lossOfLife",
  get_assets_data: "/api/powerdata/device?num_days=${data.num_days}",
  get_ber_data: "/api/powerdata/ber/device/${data.areaId}",
  get_message_list: "/api/powerdata/messages/device/${data.device_id}",
  get_evbasedata: "/api/powerdata/evbasedata/device/${data.device_id}",
  update_assets_details: "/api/powerdata/device/${data.DeviceID}",
  get_assets_overview: "/api/powerdata/device/stats/${data.duration}",
  get_comparsion_data_chart: "/api/powerdata/device/chartdata/${data.id}",
  get_chart_data: "/api/powerdata/device/intchartdata/${data.id}",
  get_evm_list: "/api/powerdata/evmodellist",
  get_hpm_list: "/api/powerdata/hpmodellist",
  get_evm_hpm_combined_data: "/api/powerdata/modelanalysis/${data.id}",
  get_evm_data: "/api/powerdata/evmodelanalysis/${data.id}",
  get_evm_fleetanalysis: "/api/powerdata/model_fleetanalysis/${data.id_ev}/${data.id_hp}",
  get_chart_stats: "/api/powerdata/device/totalstats/${data.duration}",
  get_alerts_data: "/api/alert/powerdata",
  get_active_alerts: "/api/alert/powerdata/active",
  add_alert: "/api/alert/powerdata",
  update_alert: "/api/alert/powerdata/${data.id}",
  delete_alert: "/api/alert/${data.id}",
  get_recipients_list: "/api/alert/recipients/",
  add_recipient: "/api/alert/recipients/${data.id}",
  delete_recipient: "/api/alert/recipients/${data.alert_id}/${data.recipient_id}",
};

const scv = {
  get_scavenger_data: "/api/scv/scavenger/device/${data.id}",
  get_scavenger_overview: "/api/scv/scavenger/overview/${data.id}",
  get_scavenger_events: "/api/scv/scavenger/events/${data.id}",
  get_scavenger_events_overview: "/api/scv/scavenger/events_overview",
  get_scavenger_event_waveform: "/api/scv/scavenger/waveform/${data.deviceId}/${data.startTime}",
  get_scavenger_event: "/api/scv/scavenger/event/${data.deviceId}/${data.id}/${data.subid}/${data.startTime}",
  get_scavenger_assets: "/api/scv/scavenger/list/${data.id}",
  get_scavenger_list: "/api/scv/scavenger/device_list",
  get_scavenger_tags: "/api/scv/scavenger/tags",
  update_scavenger_tags: "/api/scv/scavenger/tags",
  get_scv_overview_list: "/api/scv/scavenger/dev_overview",
  get_scavenger_chart_data: "/api/scv/scavenger/charts/${data.id}",
  get_scavenger_boxchart_data: "/api/scv/scavenger/box_chart/${data.id}",
  get_scavenger_rms_chart_data: "/api/scv/scavenger/device_custom/${data.id}",
  get_scavenger_trends_data_chart: "/api/scv/scavenger/trendsdata/${data.id}",
  get_scavenger_capacity_chart_data: "/api/scv/scavenger/capacity/${data.id}",
  get_scavenger_voltage_data: "/api/scv/scavenger/report/voltage/${data.id}",
  get_installation_images: "/api/mobile/get_image/${data.id}",
  get_acc_data: "/api/scv/scavenger/acc_power/${data.id}",
  get_enrgy_mtr_data: "/api/scv/scavenger/energy_mtr/${data.id}",
  get_device_raw_data: "/api/scv/scavenger/min_list/${data.id}",
  get_scv_donut_data: "/api/scv/scavenger/overall_stats?duration=${data.duration}",
  get_scv_capacity_donut_data: "/api/scv/scavenger/capacity?duration=${data.duration}",
  get_scv_device_list: "/api/scv/scv/device",
  get_scv_alerts_data: "/api/alert/scavenger/get_alert",
  get_scv_active_alerts: "/api/alert/scavenger/active_alert",
  add_scv_alert: "/api/alert/scavenger",
  update_scv_alert: "/api/alert/scavenger/${data.id}",
  delete_scv_alert: "/api/alert/scavenger/${data.id}",
  update_scv_active_alerts: "/api/alert/scavenger/active_alert",
  clear_scv_active_alerts: "/api/alert/scavenger/active_alert/clear",
  get_scv_recipients_list: "/api/alert/scavenger/get_recipient/${data.id}",
  add_scv_recipient: "/api/alert/scavenger/recipients/${data.id}",
  delete_scv_recipient: "/api/alert/scavenger/recipients/${data.alert_id}/${data.recipient_id}",
  get_scavenger_available_report_dates: "/api/scv/scavenger/report/available_dates/${data.type}/${data.id}",
  get_en50160_report: "/api/scv/scavenger/report/en50160/${data.type}/${data.id}/${data.year}/${data.week}",
  get_scavenger_frequency_data: "/api/scv/scavenger/report/frequency/${data.id}",
  get_scavenger_vrms_vthd_data: "/api/scv/scavenger/report/vrmsvthd/${data.id}",
  get_scavenger_flicker_data: "/api/scv/scavenger/report/flicker/${data.id}",
  get_scavenger_harmonics_data: "/api/scv/scavenger/report/harmonics/${data.id}",
  update_scv_details: "/api/scv/scavenger/list/${data.DeviceID}",
  get_sites: "/api/mobile/sites",
  get_temp_sensor_info: "/api/scv/scavenger/get_temp_sensor_info?deviceid=${data.id}",
  get_scv_report_data: "/api/scv/scavenger/report",
  get_installed_devices_report_data: "/api/scv/scavenger/report/installed_devices",
  get_scv_chart_data: "/api/scv/scavenger/chart_data/${data.id}",
  get_scv_calculated_readings: "/api/scv/scavenger/calculated_readings/${data.id}",
  send_page_screenshot: "/api/scv/scavenger/screenshot",
};

const h2 = {
  get_h2_chart_data: "/api/scv/scavenger/h2chartdata/${data.id}",
  get_scv_h2_assets: "/api/scv/scavenger/h2/device",
  get_scv_h2_asset: "/api/scv/scavenger/h2/device/${data.id}",
  get_scv_h2_overview: "/api/scv/scavenger/h2/overview",
  get_scv_h2_mesg:
    "/api/scv/scavenger/h2/list/${data.id}?duration=${data.duration}&start_date=${data.start_date}&end_date=${data.end_date}",
  get_scv_h2_gasdata: "/api/scv/scavenger/h2/gasdata/${data.id}",
  update_scv_h2_gasdata: "/api/scv/scavenger/h2/gasdata/${data.id}",
};

const weather = {
  fetch_ambient_temp_data: "/api/weather/temperatures",
  fetch_today_temp_data: "/api/weather/today/?lat=${data.lat}&lng=${data.lng}",
  fetch_weather_data:
    "/api/weather/weather_data/?chart_type=${data.chart_type}&start_date=${data.start_date}&end_date=${data.end_date}&county=${data.county}&device_id=${data.device_id}&aggregation=${data.aggregation}",
  fetch_solar_data:
    "/api/weather/solar_data/?start_date=${data.start_date}&end_date=${data.end_date}&county=${data.county}",
};

export { trafo, scv, h2, weather };
